import { React, useMemo, useState,useEffect } from "react";
import { useAsyncDebounce } from "react-table";
import { SearchBox } from "@fluentui/react";
import Search from "../../components/Search";
import { useTranslation } from "react-i18next";
// import { Label, Input } from "reactstrap";

// Component for Global Filter
export function GlobalFilter({ globalFilter, setGlobalFilter }) {
  const [value, setValue] = useState(globalFilter);
  const [val, setVal] = useState("");
  const [t, i18n] = useTranslation();
  const searchBoxStyles = { root: { width: 300 } };

  const onChangeFun = ((value) => {
    setGlobalFilter(value || undefined);
  });

  const test = () =>{
    setValue(()=>"");
    onChangeFun("");
  }

  const updateField = (event) =>{
    setValue(event.target.value);
    onChangeFun(event.target.value);
  }


  return (
    <div style={{display:"flex",justifyContent:"right",marginBottom:20}}>
 <SearchBox
        placeholder={t("button.search")}
        onClear={test}
        value={value}
        styles={searchBoxStyles}
        onKeyUp={updateField} 
          /> 
    </div>
       
  );
}

// Component for Default Column Filter
export function DefaultFilterForColumn({
  column: {
    filterValue,
    preFilteredRows: { length },
    setFilter,
  },
})
{

    const [t, i18n] = useTranslation();
    const searchBoxStyles = { root: { width: 500 } };
  return (
    <SearchBox
        placeholder={t("button.search")}
        styles={searchBoxStyles}
          onChange={(e) => {
        // Set undefined to remove the filter entirely
        setFilter(e.target.value || undefined);
      }}
      />
    // <input
    //   value={filterValue || ""}
    //   onChange={(e) => {
    //     // Set undefined to remove the filter entirely
    //     setFilter(e.target.value || undefined);
    //   }}
    //   placeholder={`Search ${length} records..`}
    //   style={{ marginTop: "10px" }}
    // />
  );
}

// Component for Custom Select Filter
export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Use preFilteredRows to calculate the options
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  // UI for Multi-Select box
  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}